export interface ManualRound {
  abGroupId?: number;
  roundId?: number;
  status?: number;
  endReason?: number;
  confirmedWinFormId?: string;
}

export interface ManualDetail {
  status?: number;
  sceneType?: number;
  mainFormStatus?: number;
  smartTestEnabled?: boolean;
  abFormList?: Array<{ formId?: string; name?: string }>;
  smartRoundHistory?: ManualRound[];
}

export interface ManualWinner {
  mainFormId: string;
  groupId: number;
  winFormId: string;
  signature: string;
}

export function manualSignature(detail: ManualDetail, mainFormId: string): string {
  const round = (detail.smartRoundHistory || []).find(item => item.status === 1);
  const id = round && (round.abGroupId ?? round.roundId);
  if (!detail.smartTestEnabled || detail.status !== 1 || id == null) return '';
  return `${mainFormId}:${id}:${(detail.abFormList || []).map(item => item.formId || '').join(',')}`;
}

export function captureManualWinner(
  detail: ManualDetail, mainFormId: string, winFormId: string,
): ManualWinner | null {
  const signature = manualSignature(detail, mainFormId);
  const round = (detail.smartRoundHistory || []).find(item => item.status === 1);
  const groupId = round && (round.abGroupId ?? round.roundId);
  if (!signature || groupId == null || !(detail.abFormList || []).some(item => item.formId === winFormId)) {
    return null;
  }
  return { mainFormId, groupId, winFormId, signature };
}

export function resolveManualWinner(
  detail: ManualDetail, selection: ManualWinner,
): 'applied' | 'retry' | 'changed' | 'unknown' {
  const round = (detail.smartRoundHistory || [])
    .find(item => (item.abGroupId ?? item.roundId) === selection.groupId);
  if (!round) return 'unknown';
  if (round.status === 2 && round.endReason === 2 && round.confirmedWinFormId === selection.winFormId) {
    return 'applied';
  }
  if (round.status !== 1) return 'changed';
  return manualSignature(detail, selection.mainFormId) === selection.signature ? 'retry' : 'changed';
}
